// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-black[data-v-09dd07a4],.font-black[data-v-09dd07a4]:hover{color:#000}.spinner-sm[data-v-09dd07a4]{width:1em;height:1em}.cursor-pointer[data-v-09dd07a4]:hover{cursor:pointer;color:#918aa0}", ""]);
// Exports
module.exports = exports;
